import {
  RECEIVE_DATA,
  INVALIDATE_CACHE,
  REQUEST_DATA,
  STAGE_WHAT_IFS,
  SET_UPDATE_CACHE_DATA,
} from './MonteCarloChartActions';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  const { type, clientId, requestedWith, whatIfs, data, updateCacheData } = action;

  switch (type) {
    case REQUEST_DATA: {
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          requestedWith,
          loading: ((state[clientId] || {}).loading || 0) + 1,
        },
      };
    }

    case INVALIDATE_CACHE:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          requestedWith: null,
          stagedWhatIfs: null,
        },
      };

    case STAGE_WHAT_IFS:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          stagedWhatIfs: whatIfs,
        },
      };

    case RECEIVE_DATA: {
      const clientState = state[clientId] || {};
      const loading = (clientState.loading || 1) - 1;
      return {
        ...state,
        [clientId]: {
          ...clientState,
          responseData: loading === 0 ? data : clientState.responseData,
          loading,
        },
      };
    }

    case SET_UPDATE_CACHE_DATA:
      return {
        ...state,
        [clientId]: {
          ...(state[clientId] || {}),
          updateCacheData,
        },
      };

    default:
      return state;
  }
};
